<div
  *ngIf="isVisible && popupData"
  class="popup-overlay"
  [class.show]="isVisible && !isClosing"
  [class.closing]="isClosing"
  (click)="onOverlayClick($event)"
>
  <div
    class="popup-content"
    [class.has-header]="hasTitle"
    [class.no-header]="!hasTitle"
    [attr.dir]="isRTL ? 'rtl' : 'ltr'"
  >
    <!-- Header with title (if exists) -->
    <div *ngIf="hasTitle" class="popup-header">
      {{ localizedContent.title }}
      <button
        class="popup-close"
        (click)="closePopup()"
        [attr.aria-label]="isRTL ? 'إغلاق' : 'Fermer'"
        [style]="isRTL ? 'left: 15px;' : 'right: 15px;'"
      ></button>
    </div>

    <!-- Close button for no-header layout -->
    <div *ngIf="!hasTitle" class="popup-close-container">
      <button
        class="popup-close"
        (click)="closePopup()"
        [attr.aria-label]="isRTL ? 'إغلاق' : 'Fermer'"
        [style]="isRTL ? 'left: 10px;' : 'right: 10px;'"
      ></button>
    </div>

    <!-- Image container with simple fallback -->
    <div *ngIf="popupData.image_url" class="popup-image-container" [class.no-header]="!hasTitle">
      <img
        [src]="popupData.image_url"
        [alt]="popupData.title || 'Popup Image'"
        loading="lazy"
        (error)="onImageError()"
        (load)="onImageLoad()"
        [style.display]="imageError ? 'none' : 'block'"
      >

      <!-- Simple fallback overlay -->
      <div *ngIf="imageError" class="image-fallback">
        <div class="fallback-content">
          <div class="fallback-icon">📋</div>
          <h3>{{ localizedContent.title || (isRTL ? 'إعلان مهم' : 'Annonce importante') }}</h3>
          <p>{{ isRTL ? 'يرجى الاطلاع على الوثيقة أدناه' : 'Veuillez consulter le document ci-dessous' }}</p>
        </div>
      </div>
    </div>

    <!-- Button section -->
    <div *ngIf="popupData.document_url && localizedContent.buttonText" class="popup-button-section">
      <button
        class="document-button"
        (click)="onDocumentButtonClick()"
        type="button"
      >
        {{ localizedContent.buttonText }}
      </button>

    </div>
  </div>
</div>